import React from 'react';

import Password from '../Password';

import './SignInContent.css';

export default ({ onSubmit, onForgotten, onChangeEmail, onChangePassword, onClose, email, password, isError }) => (
  <div className="sign-in">
    <h4>Sign In</h4>
    <form onSubmit={onSubmit}>
      <label>
          Email:
          <input type='email' value={email} onChange={onChangeEmail} required />
      </label>
      <label>
          Password:
          <Password type='password' value={password} onChange={onChangePassword} required />
      </label>
      { isError && (
        <p className='sign-in-error'>User or password was incorrect</p>
      )}
      <input type="submit" value="Submit" />
    </form>
    <button onClick={onForgotten}>I've forgotten my password</button>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/SignInModal/SignInContent.jsx